import { useParams } from "@tanstack/react-router";

export const useMerchant = () => {
  const params = useParams({ strict: false }) as { merchantId?: string };
  return params.merchantId ?? localStorage.getItem("api_key") ?? "";
};

export const useWorkspaceId = () => {
  const params = useParams({ strict: false }) as { workspaceId?: string };
  return params.workspaceId ?? null;
};
